module.exports = __webpack_public_path__ + "static/media/pink_animal_birds.fd868809.png";